define('app/views/dc_deal_filter',['app/setup'], function(takhfifan) {
  takhfifan.DCDealFilter = Backbone.View.extend({
    events: {
      'click .tkh-dc-deal-filter__item': 'filter'
    },

    initialize: function () {
      var _this = this;
      takhfifan.eventHub.on('dc:deal-filter-update', function () {
        _this.updateItems();
      });
    },

    updateItems : function(){
      var _this = this;
      if(!$('#tkh-deal-types').val()){
        this.$el.parents('.dc-block').hide();
        return;
      }
      this.allTypes = JSON.parse($('#tkh-deal-types').val());
      this.$filters = this.$('.tkh-dc-deal-filter__item');
      if(Array.isArray(this.allTypes) && this.allTypes.length){
        this.$filters.each(function () {
          if(_.indexOf(_this.allTypes, $(this).data('id').toString()) === -1){
            $(this).hide();
          } else {
            $(this).show();
          }
        });
      }else{
        this.$el.parent().hide();
      }
    },

    filter: function (e) {
      e.preventDefault();
      var $target = $(e.target),
          id =$target.data('id'),
          top = $(document).height();

      var $scrollToEl = $('.tkh-deal-item[data-type-id='+id+']').each(function(){
        top = Math.min(top, $(this).offset().top);
      });

      if($scrollToEl.length){
        $('html, body').animate({
          scrollTop: top - 90
        }, 500);
      }
    }

  })
});

